import { api } from "../lib/api";

export const cities = (days) =>
  api.get("/stats/cities", { params: days ? { days } : {} }).then((r) => r.data);

export const dashboard = ({ since, months } = {}) =>
  api.get("/stats/dashboard", { params: { since, months } }).then((r) => r.data);

/**
 * Charge toutes les données réelles nécessaires au Dashboard V2.
 *
 * Le backend applique lui-même le périmètre correspondant au rôle :
 * tenant complet, équipe du manager ou activité du commercial.
 */
export const dashboardV2 = ({
  since,
  months,
  ownerUserId,
  dateMode,
  dateFrom,
  dateTo,
} = {}) =>
  api
    .get("/stats/dashboard-v2", {
      params: {
        since,
        months,
        owner_user_id: ownerUserId || undefined,
        date_mode: dateMode || undefined,
        date_from: dateFrom || undefined,
        date_to: dateTo || undefined,
      },
    })
    .then((response) => response.data);

/**
 * Charge la carte commerciale depuis le backend authentifie.
 */
export const mapData = ({
  signal,
  ownerUserId = "",
} = {}) =>
  api
    .get("/stats/map", {
      signal,
      params: {
        owner_user_id: ownerUserId || undefined,
      },
    })
    .then((response) => response.data);

// acta_patch_lot2_crm_ca_step1
export const commercialSummary = () =>
  api.get("/stats/commercial-summary").then((r) => r.data);

